import { useEffect, useState } from "react";

const useDebouncedValue = (value, delay = 100) => {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const id = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(id);
    }, [value, delay]);

    return debounced;
}

export default useDebouncedValue